import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Broadcast, SignIn, Spinner } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Login() {
  const { signIn } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await signIn(username.trim(), password);
      toast.success("Signed in");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid username or password");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center pf-grid-bg px-4">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#E3E7EC] bg-white p-8 shadow-sm" data-testid="login-form">
        <div className="mb-6 flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-sm border border-[#E3E7EC] bg-[#F9FAFB]">
            <Broadcast size={22} weight="duotone" className="text-[#F0323E]" />
          </div>
          <div>
            <h1 className="text-lg font-semibold tracking-tight text-[#0F172A]">ProcureFlow</h1>
            <p className="pf-label">Unprocessed Order Control Tower</p>
          </div>
        </div>
        <label className="pf-label">Username</label>
        <input
          data-testid="login-username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          className="mt-1 mb-4 h-11 w-full rounded-sm border border-[#E3E7EC] bg-[#F9FAFB] px-3 text-sm text-[#0F172A] outline-none focus:border-[#F0323E] focus:bg-white"
        />
        <label className="pf-label">Password</label>
        <input
          data-testid="login-password"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="mt-1 mb-6 h-11 w-full rounded-sm border border-[#E3E7EC] bg-[#F9FAFB] px-3 text-sm text-[#0F172A] outline-none focus:border-[#F0323E] focus:bg-white"
        />
        <button
          data-testid="login-submit"
          disabled={busy}
          className="flex h-11 w-full items-center justify-center gap-2 rounded-sm bg-[#F0323E] text-sm font-semibold text-white transition-colors hover:bg-[#d92834] disabled:opacity-50"
        >
          {busy ? <Spinner size={16} className="animate-spin" /> : <SignIn size={16} weight="bold" />}
          Sign in
        </button>
      </form>
    </div>
  );
}
